import { FormContents } from '../types/page';

interface MapperItem<K extends string | number | symbol> {
  key: K;
  value: string;
}

type FormValues = Record<string, unknown>;

export const mapUndefinedStringToEmpty = (val: string): string => {
  return val === undefined || val === 'undefined' ? '' : val;
};

export const mapFormContents = <K extends string | number | symbol>(
  defaultValues: FormValues,
  watchedValues: FormValues | undefined,
  formContentMapper: MapperItem<K>[],
): Partial<FormContents> => {
  const mapValues = (source: FormValues): Partial<Record<K, unknown>> => {
    return formContentMapper.reduce(
      (acc, { key, value }) => {
        const raw = source?.[value];
        const cleaned =
          typeof raw !== 'string' ? raw : mapUndefinedStringToEmpty(raw);
        acc[key] = cleaned;
        return acc;
      },
      {} as Partial<Record<K, unknown>>,
    );
  };

  const defaultMapped = mapValues(defaultValues);
  const currentMapped = watchedValues ? mapValues(watchedValues) : {};

  return {
    ...defaultMapped,
    ...currentMapped,
  };
};
